module.exports = __webpack_public_path__ + "static/img/Jake_Lever_mobile.37faf74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake_Lever_mobile.jpg
// module id = 2WPu
// module chunks = 0